import { render, staticRenderFns } from "./drache.vue?vue&type=template&id=149b3c87&scoped=true&"
import script from "./drache.vue?vue&type=script&lang=js&"
export * from "./drache.vue?vue&type=script&lang=js&"
import style0 from "./drache.vue?vue&type=style&index=0&id=149b3c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b3c87",
  null
  
)

export default component.exports